var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    fill: "url(#paint0_linear_721_17043)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 41,
    fill: "#70DC66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_17043)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5032 37.4727C48.5236 37.4727 47.7357 38.2614 47.7357 39.2376V45.257C47.7357 46.2365 48.5232 47.0253 49.5032 47.0253C50.4794 47.0253 51.2681 46.2366 51.2681 45.257V43.2047C52.0803 43.7775 52.5626 44.7049 52.5626 45.6989C52.5626 47.3882 51.1925 48.7584 49.5032 48.7584C47.8105 48.7584 46.4407 47.3882 46.4407 45.6989V40.6424H44.2753C43.0695 40.6424 41.9223 40.9471 41.0237 41.6599C40.1264 42.3755 39.5573 43.4859 39.4347 44.7533L37.6698 72.6132C37.5876 73.8946 37.875 75.1281 38.6361 76.0626C39.3963 76.9988 40.5988 77.5839 41.931 77.5839H63.632C63.6184 77.4365 63.611 77.2891 63.611 77.1454V74.9353H42.2334C41.583 74.9353 41.1858 74.709 40.8868 74.3427C40.5887 73.9798 40.431 73.4277 40.4685 72.7265L41.5926 50.9916H74.6114L75.4509 67.2135L78.3114 69.1019L76.7662 44.7537C76.646 43.4864 76.0774 42.376 75.1796 41.6603C74.279 40.9472 73.1319 40.6428 71.9257 40.6428H68.4652V39.238C68.4652 38.2618 67.6777 37.4731 66.7015 37.4731C65.7207 37.4731 64.9332 38.2618 64.9332 39.238V45.2575C64.9332 46.237 65.7207 47.0258 66.7015 47.0258C67.6777 47.0258 68.4652 46.237 68.4652 45.2575V43.2051C69.2775 43.7779 69.7602 44.7053 69.7602 45.6994C69.7602 47.3887 68.3892 48.7588 66.7007 48.7588C65.0114 48.7588 63.6408 47.3887 63.6408 45.6994V40.6428H51.2691V39.238C51.2691 38.261 50.4804 37.4731 49.5042 37.4731L49.5032 37.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2232 55.4961H50.6154C51.2591 55.4961 51.7761 56.0139 51.7761 56.6568V60.083C51.7761 60.7268 51.2583 61.2438 50.6154 61.2438H46.2232C45.5795 61.2438 45.0625 60.7259 45.0625 60.083V56.6568C45.0621 56.0135 45.5791 55.4961 46.2232 55.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9068 55.4961H60.2989C60.9427 55.4961 61.4597 56.0139 61.4597 56.6568V60.083C61.4597 60.7268 60.9419 61.2438 60.2989 61.2438H55.9068C55.2631 61.2438 54.7461 60.7259 54.7461 60.083V56.6568C54.7461 56.0135 55.2631 55.4961 55.9068 55.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5943 55.4961H69.9865C70.6302 55.4961 71.1472 56.0139 71.1472 56.6568V60.083C71.1472 60.7268 70.6294 61.2438 69.9865 61.2438H65.5943C64.9506 61.2438 64.4336 60.7259 64.4336 60.083V56.6568C64.4328 56.0135 64.9502 55.4961 65.5943 55.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2232 64.6816H50.6154C51.2591 64.6816 51.7761 65.202 51.7761 65.8466V69.2691C51.7761 69.9137 51.2583 70.4341 50.6154 70.4341H46.2232C45.5795 70.4341 45.0625 69.9138 45.0625 69.2691V65.8466C45.0621 65.202 45.5791 64.6816 46.2232 64.6816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9068 64.6816H60.2989C60.9427 64.6816 61.4597 65.202 61.4597 65.8466V69.2691C61.4597 69.9137 60.9419 70.4341 60.2989 70.4341H55.9068C55.2631 70.4341 54.7461 69.9138 54.7461 69.2691V65.8466C54.7461 65.202 55.2631 64.6816 55.9068 64.6816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6818 66.7467L65.6719 77.1414C65.6719 78.7069 66.8293 79.4849 67.7717 78.7932L70.3931 76.854L72.4764 80.817C72.8902 81.6057 73.7677 81.9476 74.4466 81.5772L75.9853 80.741C76.6596 80.3706 76.8718 79.4431 76.4581 78.6544L74.3789 74.6873L77.8014 73.4955C78.6409 73.2036 78.5381 71.7926 77.2431 70.8572L68.6505 65.187C67.275 64.2843 65.6851 64.9137 65.6819 66.7467L65.6818 66.7467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_17043",
    x1: 58,
    y1: 0,
    x2: 58,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70DC66",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_17043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(27 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCale);
export default __webpack_public_path__ + "static/media/cale.3027367322f107c17bdb2d65f390a1ec.svg";
export { ForwardRef as ReactComponent };